import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ReportFilterBar } from '../../../components/report/ReportFilterBar';
import { KPIStatsCards } from '../../../components/report/KPIStatsCards';
import { StaffPerformanceGrid } from '../../../components/report/StaffPerformanceGrid';
import { LiveActionLogsTable } from '../../../components/report/LiveActionLogsTable';
import { StaffPerformanceChart } from '../../../components/report/StaffPerformanceChart';
import { useWarehouseReportStore } from '../../../store/warehouse/warehouseReportStore';
import { toast } from 'react-toastify';
import { useUIStore } from '../../../store/uiStore';
import { LayoutGrid, List } from 'lucide-react';
import { StaffPerformanceList } from '../../../components/report/StaffPerformanceList';

export const EmployeeHistoryReport = () => {
  const reportStore = useWarehouseReportStore();
  const abortRef = useRef<AbortController | null>(null);
  const { viewMode, setViewMode } = useUIStore();
  // 1. DÜZELTME: İlk state değerini multi-select uyumlu yapsın diye userIds: [] olarak güncelledik
  const [filters, setFilters] = useState<any>({
    userIds: [], 
    dateRange: [new Date(new Date().setHours(0,0,0,0)), new Date(new Date().setHours(23,59,59,999))],
    operationType: 'ALL',
    isLiveActive: false,
  });

  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState({ summary: null, logs: [], performance: [], totalLogs: 0 }); 
  const [loading, setLoading] = useState(false);

  const fetchReportData = useCallback(async (silent = false) => {
    if (filters.dateRange && filters.dateRange[0] && !filters.dateRange[1]) {
      return; 
    }

    if (abortRef.current) {
      abortRef.current.abort(); 
    }

    const controller = new AbortController();
    abortRef.current = controller;

    if (!silent) setLoading(true);

    try {
      // 2. DÜZELTME: API'ye giderken hem userIds dizisini hem de store'un iç yapısı
      // ya da Axios interceptor'ları doğrudan "userId" arıyorsa diye uyumluluk sağlıyoruz.
const apiFilters = {
  ...filters,
  userIds: filters.userIds || [],
  userId: filters.userIds?.[0] ?? null,
};

      const result = await reportStore.getDashboardData(apiFilters, {
        signal: controller.signal
      });

      setData({
        summary: result.summary,
        logs: result.logs,
        performance: result.performance,
        totalLogs: result.totalLogs
      });

    } catch (error: any) {
      if (error.name === "CanceledError") return;
      toast.error("Veriler alınırken hata oluştu.");
    } finally {
      if (!silent) setLoading(false);
    }
  }, [filters]);

useEffect(() => {
  const timeout = setTimeout(() => {
    fetchReportData();
  }, 200);

  return () => clearTimeout(timeout);
}, [
  filters.dateRange,
  filters.userIds,
  filters.operationType,
  filters.startDate,
  filters.endDate,
  filters.isLiveActive
]);
 
  return (
    <div className="flex flex-col gap-4 p-4 w-full">
        <div className="flex justify-between items-center gap-4">
  
      <ReportFilterBar 
      key="global-report-filter-bar"
        filters={filters} 
        onFilterChange={setFilters} 
        loading={loading}
        onRefresh={() => fetchReportData(false)}
      />
  
  <div className="flex bg-[var(--surface-variant)] p-1 rounded-lg shrink-0">
    <button onClick={() => setViewMode('grid')} className={`p-2 rounded-md ${viewMode === 'grid' ? 'bg-[var(--surface)] shadow-sm' : 'opacity-50'}`}>
      <LayoutGrid size={18} />
    </button>
    <button onClick={() => setViewMode('list')} className={`p-2 rounded-md ${viewMode === 'list' ? 'bg-[var(--surface)] shadow-sm' : 'opacity-50'}`}>
      <List size={18} />
    </button>
  </div>
</div>
      {data.summary && <KPIStatsCards data={data.summary} />}

      {/* Sekme Menüsü */}
      <div className="flex items-center gap-2 border-b border-surface-200 dark:border-surface-800 pb-2 mt-2">
        <button 
          onClick={() => setActiveTab(0)}
          className={`px-4 py-2 text-sm font-bold rounded-t-lg transition-colors ${activeTab === 0 ? 'bg-primary text-white' : 'hover:bg-surface-100 dark:hover:bg-surface-800 opacity-70'}`}
        >
          Personel Takip Gridi
        </button>
        <button 
          onClick={() => setActiveTab(1)}
          className={`px-4 py-2 text-sm font-bold rounded-t-lg transition-colors ${activeTab === 1 ? 'bg-primary text-white' : 'hover:bg-surface-100 dark:hover:bg-surface-800 opacity-70'}`}
        >
          Canlı İşlem Logları
        </button>
        <button 
          onClick={() => setActiveTab(2)}
          className={`px-4 py-2 text-sm font-bold rounded-t-lg transition-colors ${activeTab === 2 ? 'bg-primary text-white' : 'hover:bg-surface-100 dark:hover:bg-surface-800 opacity-70'}`}
        >
          Grafiksel Analiz
        </button>
      </div>

      {/* Dinamik İçerik */}
      <div className="w-full flex-1">
       {activeTab === 0 && (
  viewMode === 'grid' ? (
    <StaffPerformanceGrid performanceData={data.performance} logsData={data.logs} loading={loading} />
  ) : (
    <StaffPerformanceList performanceData={data.performance} logsData={data.logs} loading={loading} />
  )
)}

        {activeTab === 1 && (
          <div className="card-primary w-full overflow-hidden">
             <LiveActionLogsTable 
               logs={data.logs} 
               loading={loading} 
               isLiveActive={filters.isLiveActive} 
             />
          </div>
        )}

        {activeTab === 2 && (
          <div className="w-full">
            <StaffPerformanceChart data={data.performance} loading={loading} />
          </div>
        )}
      </div>
    </div>
  );
};